import type { MetaFunction } from "react-router";

import { INDEX_ROBOTS_DIRECTIVE } from "~/constants/robots";
import { ROUTES } from "~/constants/routing";
import { TypeFilterEnum } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/types";
import { DASHBOARD_HEADINGS } from "~/feature/dashboard/dashboardHeadings";
import { DashboardPage } from "~/feature/dashboard/pages/DashboardPage";
import { buildDashboardListingMetaJsonLd } from "~/jsonLD/aggregatedEventsFeed";
import {
  type DashboardEventsLoaderData,
  loadInitialAggregatedEvents,
} from "~/loaders/dashboardEvents";
import { generateMetaData } from "~/utils/generateMetaData";

import type { Route } from "./+types/binary";

const { h1, subtitle } = DASHBOARD_HEADINGS[ROUTES.binary.path];

export async function loader(): Promise<DashboardEventsLoaderData> {
  return {
    initialEvents: await loadInitialAggregatedEvents({
      typeFilter: TypeFilterEnum.Binary,
    }),
  };
}

export function clientLoader(): DashboardEventsLoaderData {
  return { initialEvents: null };
}

export const meta: MetaFunction = (metaArgs) => {
  return generateMetaData({
    seoData: { seoTitle: h1, seoDescription: subtitle },
    metaArgs,
    robotsDirective: INDEX_ROBOTS_DIRECTIVE,
    jsonLd: buildDashboardListingMetaJsonLd({
      metaArgs,
      routePath: ROUTES.binary.path,
    }),
  });
};

export default function Binary({ loaderData }: Route.ComponentProps) {
  return (
    <DashboardPage
      typeFilter={TypeFilterEnum.Binary}
      initialEvents={loaderData.initialEvents}
    />
  );
}
